export default __webpack_public_path__ + "static/media/Standard19.efe0b0a1.png";